import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
// Placeholder sections - add links as needed
const sections = [
    {
        title: "Navigation",
        links: [
            { label: "Home", path: "/", shortcut: "1" },
            { label: "Short Links", path: "/links", shortcut: "2" },
            { label: "Access Code", path: "/access-code", shortcut: "3" },
            { label: "Notifications", path: "/notifications", shortcut: "4" }
        ]
    }
];
export function Sidebar() {
    const navigate = useNavigate();
    useEffect(() => {
        function handleKeyDown(e) {
            // Don't trigger if user is typing in an input
            if (e.target instanceof HTMLInputElement ||
                e.target instanceof HTMLTextAreaElement) {
                return;
            }
            for (const section of sections) {
                for (const link of section.links) {
                    if (link.shortcut === e.key) {
                        navigate(link.path);
                        return;
                    }
                }
            }
        }
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [navigate]);
    return (_jsxs("aside", { className: "th_sidebar", children: [_jsxs("div", { className: "th_sidebar__header", children: [_jsx("h1", { children: "Treehouse" }), _jsx("span", { children: "Putty Internal Network" })] }), _jsx("nav", { className: "th_sidebar__nav", children: sections.map((section) => (_jsx("div", { className: "th_sidebar__section", children: section.links.map((link) => (_jsxs(NavLink, { to: link.path, className: ({ isActive }) => `th_sidebar__link ${isActive ? "th_sidebar__link--active" : ""}`, children: [link.shortcut && (_jsx("span", { className: "th_sidebar__shortcut", children: link.shortcut })), link.icon, link.label] }, link.path))) }, section.title))) })] }));
}
